<template>
    <div class="InstitutionalProjectReview">
        <div class="table">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column cell-class-name="custom-text-size" width="100" label="序号">
                    <template slot-scope="scope">
                        <span>{{ (page - 1) * SizePage + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="100" prop="project_title"
                    label="项目名称"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="100" prop="company_info_name"
                    label="项目机构"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" show-overflow-tooltip width="250"
                    prop="project_synopsis" label="简介"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="120" label="项目图片">
                    <template slot-scope="scope">
                        <img @click="OpenLock(scope.row.project_img)" :src="$Global.CommImgHttp + scope.row.project_img"
                            alt="">
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="status_text" label="审核结果"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" label="操作">
                    <template slot-scope="scope">
                        <el-button class="" size="mini" @click="LockInfo(scope.row)" v-if="scope.row.status === 0">审核</el-button>
                        <el-button class="" size="mini" @click="LockInfo(scope.row)" v-else>详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="PageDis">
                <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"
                    @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page"
                    :hide-on-single-page="false"></el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="ReviewBlon" width="60%" :show-close="true">
            <div class="CommDig">
                <!-- 学历教育项目详情 -->
                <template v-if="LockData.project && LockData.project.user_group_id === 6">
                    <div class="TitleBox">
                        <span>项目详情</span>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">标题</div>
                        <div class="DigCon">{{ LockData.project.title }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">简介</div>
                        <div class="DigCon">{{ LockData.project.synopsis }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">项目机构</div>
                        <div class="DigCon">{{ LockData.company_info.name }}</div>
                    </div>
                    <div class="DigItem" v-if="LockData.project.img">
                        <div class="DigTit">图片</div>
                        <div class="DigCon">
                            <img class="LockImg" :src="$Global.CommImgHttp + LockData.project.img"
                                @click="OpenLock(LockData.project.img)" alt="">
                        </div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">内容</div>
                        <div class="DigCon" v-html="LockData.project.content"></div>
                    </div>

                    <!-- 课程信息 -->
                    <div class="TitleBox" v-if="LockData.project.course && LockData.project.course.length">
                        <span>课程信息</span>
                    </div>
                    <el-table v-if="LockData.project.course && LockData.project.course.length" 
                        :data="LockData.project.course" 
                        border 
                        style="width: 100%; margin: 20px 0;">
                        <el-table-column prop="course_module" label="课程模块" width="180"></el-table-column>
                        <el-table-column prop="teaching_objective" label="教学目标" width="180"></el-table-column>
                        <el-table-column prop="content" label="课程内容" width="180"></el-table-column>
                        <el-table-column prop="teacher" label="讲师" width="120"></el-table-column>
                        <el-table-column prop="hours" label="课时" width="120"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>

                    <!-- 师资信息 -->
                    <div class="TitleBox" v-if="LockData.project.teachers && LockData.project.teachers.length">
                        <span>师资信息</span>
                    </div>
                    <el-table v-if="LockData.project.teachers && LockData.project.teachers.length" 
                        :data="LockData.project.teachers" 
                        border 
                        style="width: 100%; margin: 20px 0;">
                        <el-table-column prop="name" label="姓名" width="180"></el-table-column>
                        <el-table-column prop="title" label="职称" width="180"></el-table-column>
                        <el-table-column prop="company" label="所属单位" width="180"></el-table-column>
                        <el-table-column prop="specialty" label="专业领域" width="180"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                </template>

                <!-- 继续教育项目详情 -->
                <template v-if="LockData.project && LockData.project.user_group_id === 7">
                    <div class="TitleBox">
                        <span>项目基础信息</span>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">项目名称</div>
                        <div class="DigCon">{{ LockData.project.title }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">项目类型</div>
                        <div class="DigCon">{{ getProjectType(LockData.project.project_type) }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">开始时间</div>
                        <div class="DigCon">{{ LockData.project.start_date }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">结束时间</div>
                        <div class="DigCon">{{ LockData.project.end_date }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">项目课时</div>
                        <div class="DigCon">{{ LockData.project.total_hours }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">目标学员</div>
                        <div class="DigCon">{{ LockData.project.target_students }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">预期人数</div>
                        <div class="DigCon">{{ LockData.project.expected_students }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">收费标准</div>
                        <div class="DigCon">{{ LockData.project.fee }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">可行性分析</div>
                        <div class="DigCon">{{ LockData.project.feasibility }}</div>
                    </div>
                    <div class="DigItem" v-if="LockData.project.training_program">
                        <div class="DigTit">附件</div>
                        <div class="DigCon">
                            <el-button type="primary" size="small" @click="OpenLock(LockData.project.training_program)">
                                {{ getTrainingProgramBtnText(LockData.project.training_program) }}
                            </el-button>
                        </div>
                    </div>

                    <div class="TitleBox" v-if="LockData.project.course && LockData.project.course.length">
                        <span>课程信息</span>
                    </div>
                    <el-table v-if="LockData.project.course && LockData.project.course.length" 
                        :data="LockData.project.course" 
                        border 
                        style="width: 100%; margin: 20px 0;">
                        <el-table-column prop="course_module" label="课程模块" width="180"></el-table-column>
                        <el-table-column prop="teaching_objective" label="教学目标" width="180"></el-table-column>
                        <el-table-column prop="content" label="课程内容" width="180"></el-table-column>
                        <el-table-column prop="teacher" label="讲师" width="120"></el-table-column>
                        <el-table-column prop="hours" label="课时" width="120"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>

                    <div class="TitleBox" v-if="LockData.project.teachers && LockData.project.teachers.length">
                        <span>师资信息</span>
                    </div>
                    <el-table v-if="LockData.project.teachers && LockData.project.teachers.length" 
                        :data="LockData.project.teachers" 
                        border 
                        style="width: 100%; margin: 20px 0;">
                        <el-table-column prop="name" label="姓名" width="180"></el-table-column>
                        <el-table-column prop="title" label="职称" width="180"></el-table-column>
                        <el-table-column prop="company" label="所属单位" width="180"></el-table-column>
                        <el-table-column prop="specialty" label="专业领域" width="180"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>

                    <div class="TitleBox" v-if="LockData.project.last_experience">
                        <span>过往项目经验</span>
                    </div>
                    <div class="DigItem" v-if="LockData.project.last_experience">
                        <div class="DigCon">
                            <img class="LockImg" :src="$Global.CommImgHttp + LockData.project.last_experience"
                                @click="OpenLock(LockData.project.last_experience)" alt="项目经验">
                        </div>
                    </div>
                </template>

                <!-- 审核部分 -->
                <div class="TitleBox">
                    <span>审核</span>
                </div>
                <div class="DigItem">
                    <div class="DigTit">状态</div>
                    <div class="DigCon">
                        <el-radio-group :disabled="status_type !== 0" v-model="SetData.status" size="small">
                            <el-radio :label=1>通过</el-radio>
                            <el-radio :label=2>不通过</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="DigItem" v-if="SetData.status == 2">
                    <div class="DigTit">驳回理由</div>
                    <div class="DigCon">
                        <el-input size="small" type="textarea" :rows="5" placeholder="请输入"
                            v-model="SetData.reason"></el-input>
                    </div>
                </div>
                <div class="DigBtns">
                    <div class="Btn" @click="ReviewBlon = false, SetData = {}">取消</div>
                    <div v-if="status_type == 0" class="Btn Blue" @click="ReviewSuc">提交</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const processStatus = {
    '0': '未审核',
    '1': '已审核',
    '2': '已驳回',
}
export default {
    data() {
        return {
            tableData: [],
            total: 0,
            page: 1,
            SizePage: 10,
            ReviewBlon: false,
            LockData: {},
            SetData: {
                status: 0,
                reason: "",
            },
            status_type: 0,
        }
    },
    props: {
        SearchInfo: {
            type: Object, //类型
            required: false, //必要性
            default: {} //默认值
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            let params = {
                type: 1,
                page: this.page,
                limit: this.SizePage,
            }
            this.$post("api/user/myJudge", { ...params, ...this.SearchInfo }).then(res => {
                if (res.data.code == 1) {
                    this.total = res.data.data.total;
                    res.data.data.data.forEach(item => {
                        if (item.company_info && item.project) {
                            item.company_info_name = item.company_info.name || '';
                            item.project_title = item.project.title || '';
                            item.project_synopsis = item.project.synopsis || '';
                            item.project_img = item.project.img || '';
                            item.status = item.status;
                            item.status_text = processStatus[item.status];
                        }
                    });
                    this.tableData = res.data.data.data;
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        LockInfo(row) {
            if (!row || !row.id) {
                this.$message.error("项目数据不完整");
                return;
            }
            
            this.$post("api/user/myJudgeDetails", {
                type: 1,
                ids: row.id,
            }).then(res => {
                if (res.data.code == 1) {
                    this.LockData = res.data.data;
                    if (this.LockData.project) {
                        this.LockData.project.img = this.LockData.project.img || '';
                        this.LockData.project.content = this.LockData.project.content || '';
                        this.LockData.project.synopsis = this.LockData.project.synopsis || '';
                        this.ReviewBlon = true;
                        this.SetData.reason = this.LockData.reason || '';
                        this.SetData.status = this.LockData.status || 0;
                        this.status_type = this.LockData.status;
                    } else {
                        this.$message.error("项目详情数据不完整");
                    }
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        ReviewSuc() {
            if (!this.SetData.status) {
                this.$message.error("请选择审核状态!");
                return
            }
            if (this.SetData.status == 2 && !this.SetData.reason) {
                this.$message.error("请输入驳回理由!");
                return
            }
            this.$confirm("确认提交审核结果?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                var params = {
                    type: 1,
                    ids: this.LockData.id,
                    status: this.SetData.status,
                }
                if (this.SetData.status == 2) {
                    params.reason = this.SetData.reason;
                }
                this.$post("api/user/examine", params).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success(res.data.msg);
                        this.getData();
                        this.ReviewBlon = false;
                        this.SetData = {
                            status: "",
                            reason: "",
                        };
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            }).catch(() => {
                    this.$message.info("已取消提交");
            });
        },
        OpenLock(res) {
            this.$Global.previewFile(res)
        },
        SizeChange(val) {
            this.SizePage = val;
            this.getData();
        },
        PageChange(val) {
            this.page = val;
            this.getData();
        },
        getProjectType(type) {
            const typeMap = {
                '1': '线上',
                '2': '线下',
                '3': '线上线下结合'
            }
            return typeMap[type] || '未知'
        },
        getTrainingProgramBtnText(path) {
            if (!path || typeof path !== 'string') return '查看培训方案';
            const ext = path.split('.').pop().toLowerCase().split('?')[0];
            if (ext === 'pdf') return '查看培训方案';
            if (ext === 'doc' || ext === 'docx') return '查看培训方案';
            return '查看培训方案';
        },
    }
}
</script>
<style scoped>
.PageDis {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.CommDig {
    margin-top: 10px;
    max-height: calc(90vh - 100px);
    overflow-y: auto;
    padding: 0 20px;
}

.TitleBox {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 25px 0 15px 0;
    padding-left: 10px;
    border-left: 4px solid #027cfb;
}

.DigItem {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
}

.DigItem .DigTit {
    font-size: 15px;
    color: #666;
    width: 100px;
    flex-shrink: 0;
    line-height: 32px;
}

.DigItem .DigCon {
    width: calc(100% - 100px);
    line-height: 1.6;
    color: #333;
}

.DigItem input,
.DigItem textarea {
    border-radius: 4px;
    border: solid 1px #e1e1e1;
    padding: 8px 12px;
    width: 100%;
}

.LockImg {
    cursor: pointer;
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #eee;
}

.DigBtns {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    border-top: 1px solid #eee;
    margin-top: 20px;
}

.DigBtns .Btn {
    background-color: #f6faff;
    border-radius: 4px;
    border: solid 1px #d6e5ff;
    font-size: 14px;
    color: #2354f4;
    padding: 8px 30px;
    cursor: pointer;
    transition: all 0.3s;
}

.DigBtns .Btn:hover {
    box-shadow: 0 2px 8px rgba(182, 208, 237, 0.4);
}

.DigBtns .Btn.Blue {
    background-color: #027cfb;
    color: #fff;
    margin-left: 20px;
    border: none;
}

.DigBtns .Btn.Blue:hover {
    background-color: #0066d9;
}

/* 表格样式优化 */
.el-table {
    margin: 15px 0 25px 0 !important;
}

.el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 500;
}

.el-table--border {
    border-radius: 4px;
    overflow: hidden;
}
</style>
<style>
.InstitutionalProjectReview .el-dialog {
    margin-top: 5vh !important;
    margin-bottom: 5vh !important;
}

.InstitutionalProjectReview .el-dialog__body {
    padding: 20px 0;
}

.InstitutionalProjectReview .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
}

.InstitutionalProjectReview .el-table .cell {
    line-height: 1.6;
    padding: 8px 12px;
}
</style>